function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_8127",
  "data-name": "Path 8127",
  d: "M253.926,245.645a8,8,0,1,0,8,8A8.009,8.009,0,0,0,253.926,245.645Zm0,14.815a6.815,6.815,0,1,1,6.815-6.815A6.822,6.822,0,0,1,253.926,260.46Z",
  transform: "translate(-245.926 -245.645)",
  fill: "#95A1B2"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2932",
  "data-name": "Group 2932",
  transform: "translate(6.5 3.799)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2934",
  "data-name": "Group 2934",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  cx: 1.11,
  cy: 1.11,
  r: 1.11,
  transform: "translate(0.407)",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1378",
  "data-name": "Path 1378",
  d: "M200.049,201.418v.859h-3.033v-.859h.553v-3.637h-.553v-.859h2.48v4.5Z",
  transform: "translate(-197.016 -193.749)",
  fill: "#95A1B2"
})));

var SvgInfoGrey = function SvgInfoGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_676_2",
    "data-name": "Component 676 \\u2013 2",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-grey.6f2912e3.svg";
export { ForwardRef as ReactComponent };